export const BackendApiBaseUrl = () => {
  const curPage = window.location.hostname;
  if (curPage.includes("localhost")) return "https://localhost:5001";
  return "https://zdservice.azurewebsites.net";
};

export const BaseUrl = (baseUrl) => {
  let curPage = window.location.hostname;
  if (curPage.includes("dev") || curPage.includes("localhost")) {
    baseUrl =
      "https://zeblobstorage.blob.core.windows.net/zeblob/ProjectDb/Tvs/NewAchri/";
  }
  return baseUrl;
};

export const VehicleCode = 1161;
export const VehicleName = "RTR-310";

export const ConfigBaseUrl = (baseUrl) => {
  let curPage = window.location.hostname;
  if (
    curPage.includes("dev") ||
    curPage.includes("localhost") ||
    curPage.includes("staging")
  ) {
    // baseUrl = "https://zdvservice.azurewebsites.net/api/arive/";
    baseUrl = "https://zdvservice.azurewebsites.net/api/preprod/arive/";
  } else {
    baseUrl = "https://zdvservice.azurewebsites.net/api/arive/";
  }
  return baseUrl;
};
